import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/queryKeys'
import { fetchSearchResults } from '@/api/search'
import type { SearchKind, SearchDateRange, SearchResult } from '@/api/search'

export type { SearchKind, SearchDateRange, SearchResult }

export interface SearchOptions {
  kind?: SearchKind
  dateRange?: SearchDateRange
  journalType?: import('@/types').JournalEntry['type'] | null
}

export function useFullTextSearch(
  query: string,
  options: SearchOptions = {},
): SearchResult[] | undefined {
  const { kind = 'all', dateRange = 'all', journalType = null } = options
  const q = query.trim()

  const { data } = useQuery({
    queryKey: queryKeys.search(q, kind, dateRange, journalType),
    queryFn: () => fetchSearchResults(q, kind, dateRange, journalType),
    enabled: q.length >= 2,
  })
  return q.length < 2 ? [] : data
}
